import { render, staticRenderFns } from "./IdentifierRule.vue?vue&type=template&id=9296fe50&"
import script from "./IdentifierRule.vue?vue&type=script&lang=ts&"
export * from "./IdentifierRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports